import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, AccessLevels } from 'utility/interface';

const Navdata = () => {
  const history = useNavigate();
  const [isOrganization, setIsOrganization] = useState<boolean>(false);
  const [isUser, setIsUser] = useState<boolean>(false);
  const [isProperties, setIsProperties] = useState<boolean>(false);
  const [user, setUser] = useState<User | undefined>();
  const [iscurrentState, setIscurrentState] = useState('Dashboard');

  function updateIconSidebar(e) {
    if (e?.target?.getAttribute('sub-items')) {
      const ul = document.getElementById('two-column-menu');
      const iconItems = ul?.querySelectorAll('.nav-icon.active') || [];
      iconItems.forEach(item => {
        item.classList.remove('active');
        const id = item.getAttribute('sub-items');
        const getID = document.getElementById(id) as HTMLElement;
        if (getID) getID.classList.remove('show');
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove('twocolumn-panel');
    if (iscurrentState !== 'Properties') setIsProperties(false);
    if (iscurrentState !== 'Organization') setIsOrganization(false);
    if (iscurrentState !== 'User') setIsUser(false);
  }, [history, iscurrentState]);

  useEffect(() => {
    const userObj = sessionStorage.getItem('authUser');
    if (userObj) {
      const parsedUser = JSON.parse(userObj);
      setUser(parsedUser);
    }
  }, []);

  const allMenuItems = [
    {
      id: 'organization',
      label: 'Mazaraat',
      icon: 'ri-building-2-line',
      link: '/organizations',
      stateVariables: isOrganization,
      click: e => {
        e.preventDefault();
        setIsOrganization(!isOrganization);
        setIscurrentState('Organization');
        updateIconSidebar(e);
      },
    },
    {
      id: 'properties',
      label: 'Properties',
      icon: 'ri-user-line',
      link: `/organizations/properties`,
      stateVariables: isProperties,
      click: e => {
        e.preventDefault();
        setIsProperties(!isProperties);
        setIscurrentState('Properties');
        updateIconSidebar(e);
      },
    },
    {
      id: 'user',
      label: 'Users',
      icon: 'ri-user-line',
      link: `/organizations/users`,
      stateVariables: isUser,
      click: e => {
        e.preventDefault();
        setIsUser(!isUser);
        setIscurrentState('User');
        updateIconSidebar(e);
      },
    },
  ];

  // Filter logic
  const getFilteredMenuItems = () => {
    if (!user?.accessLevels) return [];

    const access = user.accessLevels;

    if (access.includes(AccessLevels.SUPER_ADMIN)) {
      return allMenuItems;
    }

    if (
      access.includes(AccessLevels.ADMIN) ||
      access.includes(AccessLevels.MANAGER)
    ) {
      return allMenuItems.filter(item => item.id !== 'organization');
    }

    if (access.includes(AccessLevels.RENT_COLLECTOR)) {
      return allMenuItems.filter(item => item.id === 'properties');
    }

    return [];
  };

  const menuItems = [
    {
      label: 'Menu',
      isHeader: true,
    },
    ...getFilteredMenuItems(),
  ];

  return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
